import { MrbBaseRouteStore } from "mrb/core";
import { ProducerAnalyticsService } from "common/services";

class ProducerPaymentReportPreviewRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
        this.service = rootStore.createApplicationService(ProducerAnalyticsService);
    }

    async getProducerPaymentSummary(producerId, options) {
        const response = await this.service.getProducerPaymentSummary(producerId, options);
        return response.data;
    }

    async findProducerReportItems(filter, abortSignal = null) {
        const response = await this.service.findProducerReportItems(filter, abortSignal);
        return response.data;
    }

    async findProducerReportPayoutUserEvents(params) {
        const response = await this.service.findProducerReportPayoutUserEvents(params);
        return response.data;
    }

    async findProducerReportTrackItems(filter, abortSignal = null) {
        const response = await this.service.findProducerReportTrackItems(filter, abortSignal);
        return response.data;
    }

    async findProducerReportTrackListeners(filter) {
        const response = await this.service.findProducerReportTrackListeners(filter);
        return response.data;
    }

    async findProducerReportContentItems(filter, abortSignal = null) {
        const response = await this.service.findProducerReportContentItems(filter, abortSignal);
        return response.data;
    }

    async getProducerReportTrackItemsCsv(filter, producerId) {
        const response = await this.service.getProducerReportTrackItemsCsv(filter, producerId);
        return response.data;
    }
}

export default ProducerPaymentReportPreviewRouteStore;
